let toggleTabs = document.querySelectorAll('.toggle-content .tab')

if(toggleTabs.length) {
    for(let tab of toggleTabs) {
        tab.open = () => {
            let siblings = tab.siblings()
            let index = tab.index()
            let wrapper = tab.closest('.toggle-content')
            let content = wrapper.querySelectorAll('.tab-content')

            if(siblings.length) {
                for(let sibling of siblings) {
                    sibling.classList.remove('active')
                }
            }

            tab.classList.add('active')

            if(content.length) {
                for(let item of content) {
                    let itemIndex = item.index()

                    if(itemIndex == index) {
                        item.classList.add('active')
                    } else {
                        item.classList.remove('active')
                    }
                }
            }
        }

        tab.addEventListener('click', tab.open)
    }

    toggleTabs[0].open()
}